module.exports = __webpack_public_path__ + "img/homeTopBack.7e6306fb.png";